import * as Sentry from "@sentry/browser";
import { isDev } from "shared/constants/Environment";
import { isDevHeadlessNetworkNoise } from "./devHeadlessNetworkNoise";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (!isDev) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ["localhost"],
    beforeSend: (event) => (isDevHeadlessNetworkNoise(event) ? null : event),
  });
}

export const logError: typeof Sentry.captureException = (
  exception,
  captureContext,
) => {
  // biome-ignore lint/suspicious/noConsole: mirrors the error to the browser console alongside Sentry
  console.error(exception);
  return Sentry.captureException(exception, captureContext);
};

export const logWarning: typeof Sentry.captureMessage = (
  message,
  captureContext = "warning",
) => {
  console.warn(message);
  return Sentry.captureMessage(message, captureContext);
};

export const logMessage: typeof Sentry.captureMessage = (
  message,
  captureContext,
) => {
  console.info(message);
  return Sentry.captureMessage(message, captureContext);
};
